import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Transport-level WebSocket open signals from Apollo GraphQL bootstrap.
 * Prefer {@link ReconnectingGraphqlSubscription} for long-lived GraphQL subscriptions.
 */
@Injectable({
  providedIn: 'root',
})
export class GraphqlWsLifecycleService {
  private readonly openedSubject = new Subject<void>();

  /** Fires each time the subscription WebSocket becomes ready (including reconnect). */
  readonly opened$ = this.openedSubject.asObservable();

  notifyOpened(): void {
    this.openedSubject.next();
  }
}
